import type { KeyboardEvent, SyntheticEvent } from "react";

/** A field the contributor types in: their own text stays copyable and editable. */
export function isEditableTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  return target.isContentEditable || target.closest("input, textarea, [contenteditable='true']") !== null;
}

/** Blocks copy, cut, drag and the context menu outside fields. */
export function blockOutsideFields(event: SyntheticEvent) {
  if (!isEditableTarget(event.target)) event.preventDefault();
}

/** Ctrl/Cmd+A would select the whole task: blocked outside fields. */
export function blockSelectAllOutsideFields(event: KeyboardEvent) {
  if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "a" && !isEditableTarget(event.target)) {
    event.preventDefault();
  }
}

/** Props that protect a contribution page: spread them on its root element. */
export const copyProtectionProps = {
  onCopy: blockOutsideFields,
  onCut: blockOutsideFields,
  onContextMenu: blockOutsideFields,
  onDragStart: blockOutsideFields,
  onKeyDownCapture: blockSelectAllOutsideFields,
};
